// extracted by mini-css-extract-plugin
export default {"root":"NewUserModal_root__jrvgF","button":"NewUserModal_button__Q6d2K"};